import { getParsedTrackingParams } from 'marketplace-ui-common/utils/trackingParams';
import events from '../../events.yaml';
const getSessionUrlParams = () => {
  const trackingParams = getParsedTrackingParams();
  return Object.keys(trackingParams).reduce((final, key) => {
    const value = trackingParams[key];
    final.push(`${key}=${value}`);
    return final;
  }, []);
};
export const getTrackerConfig = (inAppOrPublic = 'in-app') => ({
  events,
  properties: {
    namespace: 'marketplace',
    type: 'integration',
    inAppOrPublic,
    sessionUrlParams: getSessionUrlParams()
  },
  lastKnownEventProperties: ['screen']
});
export const getAppRecommendationType = result => {
  return result.recommendation ? `${result.recommendation.source}-v${result.recommendation.version}` : null;
};

// Track the recommendation type if the search result has recommendations
// Returns an array of unique recommendation types
export const getAppRecommendationTypes = results => {
  return results.reduce((final, result) => {
    const recommendationType = getAppRecommendationType(result);
    if (recommendationType && !final.includes(recommendationType)) {
      final.push(recommendationType);
    }
    return final;
  }, []);
};